<template>

  <div class="RecoveryModulo" :class="{ 'mobile': isMobile() }">
    <h1>{{ $t('recovery.title') }}</h1>
    <el-form :model="UserForm" :rules="rulesUserForm" ref="UserForm" class="" :show-message=false>
      <el-form-item prop="username">
        <el-input v-model="UserForm.username" v-bind:placeholder="$t('recovery.username')" :disabled="verifyUser"
          v-on:keyup.enter.native="verifyUsername()"></el-input>
        <!--<icon name="riv-filter" scale="1.5" style="width: 20%;" @click.native="secretQuestion()"></icon>-->
      </el-form-item>
      <el-form-item>
        <el-button v-if="!verifyUser" @click="verifyUsername()" class="btnSecretQuestion">{{
          $t('recovery.btn.checkUser') }}</el-button>
        <el-button v-else @click="changeUsername()" class="btnSecretQuestion">{{ $t('recovery.btn.changeUser') }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-form :model="RecPwdForm" :rules="rulesPwdForm" ref="RecPwdForm" class="" :show-message=false>
      <el-form-item class="recovery" prop="rqsQstn">
        <el-select v-model="RecPwdForm.rqsQstn" :disabled=true v-bind:placeholder="$t('recovery.rqsQstn')">
          <el-option v-for="item in secretQuestions" :key="item.value" :label="$t('questions.' + item.value)"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="ansQstn">
        <el-input v-model="RecPwdForm.ansQstn" v-bind:placeholder="$t('recovery.ansQstn')"
          :disabled="!verifyUser"></el-input>
      </el-form-item>
      <el-form-item prop="pwd">
        <el-input v-model="RecPwdForm.pwd" v-bind:placeholder="$t('recovery.pwd')" type="password"
          :disabled="!verifyUser"></el-input>
      </el-form-item>
      <el-form-item prop="pwdRep">
        <el-input v-model="RecPwdForm.pwdRep" v-bind:placeholder="$t('recovery.pwdRepeat')" type="password"
          :disabled="!verifyUser"></el-input>
      </el-form-item>
      <el-form-item>
        <span class="my-label">{{ $t('recovery.pwdExpiry') }}</span>
        <el-radio-group v-model="RecPwdForm.pwdExpiry" :disabled="!verifyUser">
          <el-radio :label="'SI'">{{ $t('recovery.yes') }}</el-radio>
          <el-radio :label="'NO'">{{ $t('recovery.no') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitFormPwd()" class="btnSecretQuestion">{{ $t('recovery.btn.pwdRecovery') }}
        </el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  name: 'Recovery',
  props: ['language'],
  i18n: {
    messages: {
      it_IT: {
        recovery: {
          title: 'Recupera Utente e Password',
          username: 'Username *',
          rqsQstn: 'Domanda Segreta',
          ansQstn: 'Risposta Segreta *',
          pwd: 'Password *',
          pwdRepeat: 'Repeat Password *',
          pwdExpiry: 'Rinuncia Scadenza Password',
          yes: 'Si',
          no: 'No',
          btn: {
            checkUser: 'Verifica Username',
            changeUser: 'Cambia Username',
            pwdRecovery: 'Recupera Password',
            userRecovery: 'Recupera Username'
          },
          msg: {
            errLogin: 'Username o password errati',
            1902: 'Timeout Exception: no response received',
            1903: 'Parametri della richiesta non validi',
            1907: 'Utente non presente',
            1908: 'Domanda Segreta non presente. Impossibile recuperare la Password',
            1909: 'Risposta Segreta errata',
            1910: 'Errore nell\'invio della mail',
            1913: 'Indirizzo eMail non presente nel sistema',
            1914: 'Impossibile procedere con la richiesta, l\'indirizzo eMail è associato a più profili',
            1915: 'Il nome Utente verr&agrave; inviato all&#39;indirizzo eMail indicato',
            1916: 'La Password Temporanea verr&agrave; inviata all&#39;indirizzo eMail inserito in fase di Registrazione',
            1998: 'Numero di filtri trovati non corretto',
            1999: 'Errore di autenticazione al servizio'
          }
        }
      },
      en_GB: {
        recovery: {
          title: 'Recover User and Password',
          username: 'Username *',
          rqsQstn: 'Secret Question',
          ansQstn: 'Secret Answer *',
          pwd: 'Password *',
          pwdRepeat: 'Repeat Password *',
          pwdExpiry: 'Password Expiration Waiver',
          yes: 'Yes',
          no: 'No',
          btn: {
            checkUser: 'Verify Username',
            changeUser: 'Change Username',
            pwdRecovery: 'Recover Password',
            userRecovery: 'Recover User'
          },
          msg: {
            errLogin: 'Username o password errati',
            1902: 'Timeout Exception: no response received',
            1903: 'Request parameter error',
            1907: 'This User does not exist',
            1908: 'Secret Question not present. Unable to recover the password',
            1909: 'Secret answer wrong',
            1910: 'Error in sending the mail',
            1913: 'E-mail adress not found in the system',
            1914: 'Unable to proceed with the request, the eMail address is associated with multiple profiles',
            1915: 'User name will be sent to the appointed e-mail address.',
            1916: 'Temporary password will be sent to the e-mail address indicated during registration operation',
            1998: 'Number of filters found incorrect',
            1999: 'Authentication error in the service'
          }
        }
      },
      es_ES: {
        recovery: {
          title: 'Recuperar nombre de usuario y contraseña',
          username: 'Usuario *',
          rqsQstn: 'Pregunta secreta',
          ansQstn: 'Respuesta secreta *',
          pwd: 'Contraseña *',
          pwdRepeat: 'Confirme contraseña *',
          pwdExpiry: 'Exención de caducidad de contraseña',
          yes: 'Si',
          no: 'No',
          btn: {
            checkUser: 'Verifica Usuario',
            changeUser: 'Cambie Usuario',
            pwdRecovery: 'Recuperar Contraseña',
            userRecovery: 'Recuperar Usuario'
          },
          msg: {
            errLogin: 'Username o password errati',
            1902: 'Timeout Exception: no response received',
            1903: 'Par&aacute;metros de la solicitud  no v&aacute;lidos',
            1907: 'Usuario no existente',
            1908: 'Pregunta secreta no presente. No se puede recuperar la contraseña',
            1909: 'Respuesta secreta equivocada',
            1910: 'Error al enviar el correo',
            1913: 'Este correo electr&oacute;nico no est&aacute; registrado por  el sistema',
            1914: 'No se puede continuar con la solicitud, la dirección de correo electrónico está asociada a múltiples perfiles',
            1915: 'El nombre de usuario ser&aacute; enviado a la direcci&oacute;n de correo electr&oacute;nico indicada.',
            1916: 'La contrase&ntilde;a temporal ser&aacute; enviada a la direcci&oacute;n de correo electr&oacute;nico introducida en nuestro sistema',
            1998: 'Cantidad de filtros encontrados incorrectos',
            1999: 'Error de autenticación en el servicio'
          }
        }
      },
      fr_FR: {
        recovery: {
          title: 'Récupération utilisateur et mot de passe',
          username: 'Utilisateur *',
          rqsQstn: 'Question de sécurité',
          ansQstn: 'Réponse secrète *',
          pwd: 'Mot de passe *',
          pwdRepeat: 'Confirmer le mot de passe *',
          pwdExpiry: 'Renoncer à l\'échéance du mot de passe',
          yes: 'Oui',
          no: 'Non',
          btn: {
            checkUser: 'Vérifiez Utilisateur',
            changeUser: 'Changer Utilisateur',
            pwdRecovery: 'Récupération mot de passe',
            userRecovery: 'Récupération Utilisateur'
          },
          msg: {
            errLogin: 'Username o password errati',
            1902: 'Timeout Exception: no response received',
            1903: 'Les param&egrave;tres de la demande ne sont pas valables',
            1907: 'Utilisateur non reconnu',
            1908: 'Question de sécurité non présente. Impossible de récupérer le mot de passe',
            1909: 'R&eacute;ponse de s&eacute;curit&eacute; inexacte',
            1910: 'Erreur lors de l\'envoi du mail',
            1913: 'Adresse email inexistante dans le syst&egrave;me',
            1914: 'Impossible de poursuivre la demande, l\'adresse e-mail est associée à plusieurs profils',
            1915: 'Le nom d&#39;utilisateur sera envoy&eacute; &agrave; l&#39;adresse mail indiqu&eacute;e',
            1916: 'Le mot de passe provisoire sera envoy&eacute; &agrave; l&#39;adresse mail saisie durant l&#39;inscription',
            1998: 'Nombre de filtres trouvés incorrects',
            1999: 'Erreur d\'authentification dans le service'
          }
        }
      },
      de_DE: {
        recovery: {
          title: 'Benutzername und Passwort wiederherstellen',
          username: 'Benutzer *',
          rqsQstn: 'Geheime Frage',
          ansQstn: 'Geheime Antwort *',
          pwd: 'Passwort *',
          pwdRepeat: 'Passwort wiederholen *',
          pwdExpiry: 'Verzicht auf Ablauf des Passworts',
          yes: 'Ja',
          no: 'Nein',
          btn: {
            checkUser: 'Benutzerüberprüfung',
            changeUser: 'Benutzernamen ändern',
            pwdRecovery: 'Passwort zurücksetzen',
            userRecovery: 'Benutzername wiederherstellen'
          },
          msg: {
            errLogin: 'Username o password errati',
            1902: 'Timeout Exception: no response received',
            1903: 'Ung&uuml;ltige Parameter in der Anfrage',
            1907: 'Benutzer nicht existent',
            1908: 'Geheime Frage nicht vorhanden. Das Passwort konnte nicht wiederhergestellt werden',
            1909: 'Falsche geheime Antwort',
            1910: 'Fehler beim Senden der E-Mail',
            1913: 'Emailadresse existiert nicht im System',
            1914: 'Nicht in der Lage, mit der Anfrage fortzufahren, Die E-Mail-Adresse ist mehreren Profilen zugeordnet',
            1915: 'Der Benutzername wird an die angegebene Emailadresse geschickt',
            1916: 'Das tempor&auml;re Passwort wird an die bei der Registrierung vermerkte Emailadresse geschickt',
            1998: 'Anzahl der gefundenen Filter nicht korrekt',
            1999: 'Authentifizierungsfehler im Dienst'
          }
        }
      }
    }
  },
  data() {
    var validatePwdRepeat = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'))
      } else if (value !== this.RecPwdForm.pwd) {
        callback(new Error('Two inputs don\'t match!'))
      } else {
        callback()
      }
    }
    return {
      secretQuestions: [{
        value: 'q1'
      }, {
        value: 'q2'
      }, {
        value: 'q3'
      }, {
        value: 'q4'
      }, {
        value: 'q5'
      }, {
        value: 'q6'
      }, {
        value: 'q7'
      }, {
        value: 'q8'
      }],
      verifyUser: false,
      UserForm: {
        username: ''
      },
      RecPwdForm: {
        rqsQstn: '',
        ansQstn: '',
        pwd: '',
        pwdRep: '',
        pwdExpiry: 'NO'
      },
      rulesUserForm: {
        username: [
          { required: true, trigger: 'blur' }
        ]
      },
      rulesPwdForm: {
        rqsQstn: [
          { required: true, trigger: 'change' }
        ],
        ansQstn: [
          { required: true, trigger: 'blur' }
        ],
        pwd: [
          { required: true, trigger: 'blur' }
        ],
        pwdRep: [
          { validator: validatePwdRepeat, trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount: function () {
  },
  methods: {
    verifyUsername: function () {
      this.$refs['UserForm'].validate((valid) => {
        if (valid) {
          var obj = {
            params: {
              username: this.UserForm.username.trim().toUpperCase(),
              codLang: sessionStorage.getItem('codLang')
            }
          }
          this.$http.get('noauth/secretQuestion', obj).then(response => {
            if (response.status === 200) {
              if (response.body.rc === 0) {
                this.RecPwdForm.rqsQstn = response.body.attrib.domanda
                this.verifyUser = true
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
          }, response => {
            this.$message({
              showClose: true,
              message: response.status + '(' + response.statusText + ')',
              type: 'error',
              duration: process.env.duration
            })
          })
        }
      })
    },
    changeUsername: function () {
      this.RecPwdForm.rqsQstn = ''
      this.RecPwdForm.ansQstn = ''
      this.RecPwdForm.pwd = ''
      this.RecPwdForm.pwdRep = ''
      this.RecPwdForm.pwdExpiry = 'NO'
      this.verifyUser = false
    },
    submitFormPwd: function () {
      this.$refs['RecPwdForm'].validate((valid) => {
        if (valid) {
          var obj = {
            username: this.UserForm.username,
            rqsQstn: this.RecPwdForm.rqsQstn,
            ansQstn: this.RecPwdForm.ansQstn,
            pwd: this.RecPwdForm.pwd,
            pwdExpiry: this.RecPwdForm.pwdExpiry,
            codLang: sessionStorage.getItem('codLang')
          }
          this.$http.post('noauth/pwdRecovery', obj, { emulateJSON: true }).then(response => {
            if (response.body.rc === 0) {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'success',
                duration: process.env.duration
              })
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              //var errCode = response.body.msg[0].msgId
              //this.$message.error(this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].recovery.msg[errCode])
            }
          }, response => {
            //this.validateStep1 = false
            this.$message({
              showClose: true,
              message: response.status + '(' + response.statusText + ')',
              type: 'error',
              duration: process.env.duration
            })
          })
        }
      })
    },
    tabClick: function (tab, event) {
      if (tab.label === 'Password') {
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.RecoveryModulo {
  height: 500px;
  padding: 15px 15px;

  h1 {
    text-align: right;
    .set-font(@weight: 300, @size: 24px, @color: #fff);
    margin-bottom: 20px;
  }

  .el-tabs {
    padding-top: 30px;
    max-width: 300px;
    text-align: center;
    margin-right: auto;
    margin-left: auto;

    .el-tabs__header {
      margin-bottom: 10px;
      height: 25px;
      width: 100%;

      .el-tabs__nav-wrap {
        border-bottom: 0px;
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }

      .el-tabs__nav {
        width: 100%;

        .is-active {
          color: #fff;
        }

        .el-tabs__active-bar {
          background-color: #fff;
          height: 2px;
          width: 100%;
        }
      }

      .el-tabs__item {
        .set-font(@weight: 300, @size: 18px, @color: #000);
        width: 150px;
        text-align: center;
        height: 30px;
        line-height: 21px;
        padding-right: 0px;
        padding-left: 0px;
      }

      .el-tabs__item:hover {
        color: #fff;
      }
    }

    .el-tabs__item:hover {
      color: #fff;
    }

    .el-tabs__active-bar {
      background-color: #000;
    }
  }

  .el-form-item {
    text-align: center;
    margin-bottom: 0;

    .el-form-item__content {
      line-height: 35px;
    }

    .fa-icon {
      .set-font(@weight: 300, @size: 18px, @color: #fff);
    }

    &.is-error {
      .el-input__inner {
        outline: #f56c6c solid 1px;
        outline: rgba(255, 0, 0, 0.9) solid 1px;
        outline-offset: 0px;
      }
    }

    .el-select {
      width: 100%;
    }

    .el-input {
      width: 100%;

      .el-input__inner {
        .set-font(@weight: 300, @size: 14px, @color: #000);
        display: block;
        margin: 5px auto;
        padding: 10px;
        max-width: 300px;
        border: 0;
        background-color: #fff;
        //background-color: rgba(255, 255, 255, .7);
        border: none;
        border-radius: 0px;
        // line-height: 0;
        height: 30px;

        &:focus {
          outline: #000 solid 1px;
          outline: rgba(0, 0, 0, .4) solid 1px;
          outline-offset: 0px;
        }
      }

      ::placeholder {
        .set-font(@weight: 300, @size: 14px, @color: #a2a2a2, @family: 'os-lightitalic');
      }
    }

    &.recovery {
      padding-top: 30px;
    }

    .el-button {
      width: 100%;
      .set-font(@weight: 300, @size: 14px, @color: #fff);
      background-color: #000;
      background-color: rgba(0, 0, 0, .6);
      font-weight: 300;
      /*margin-top: 50px;*/
      /*margin-bottom: 45px;*/
      /*width:250px;*/
      transition: background-color .3s;
      border: 0;
      border-radius: 0;
      max-width: 300px;
      text-align: center;

      &:hover {
        background-color: #000;
        background-color: rgba(0, 0, 0, .8);
        cursor: pointer;
      }

      &:focus {
        outline: 0
      }

      &.btnSecretQuestion {
        margin: 5px auto;
        /*margin-top: 0px;*/
        /*margin-bottom: 10px;*/
      }

      &.btnRecovery {
        margin: 5px auto;
        /*margin-top: 0px;*/
        /*margin-bottom: 10px;*/
      }
    }

    .el-radio-group {
      width: 150px;

      .el-radio__label {
        color: #000000;
      }
    }

    .my-label {
      display: block;
      color: #000000;
    }
  }

  .errorLogin {
    .set-font(@weight: 300, @size: 14px, @color: #d20e0e);
    //display: block;
    height: 22px;
    text-align: center;
  }

  .el-tabs__active-bar {
    width: 150px !important;
  }

  .secondTabSelected {
    .el-tabs__active-bar {
      transform: translateX(150px) !important;
    }
  }

  &.mobile {
    h1 {
      text-align: left;
      .set-font(@weight: 900, @size: 24px, @color: #fff);
      margin-bottom: 40px;

      span {
        .set-font(@weight: 300, @size: 24px, @color: #fff);
      }
    }

    .el-input {
      width: 100%;

      .el-input__inner {
        height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Recovery.vue